import { FormattedMessage } from "react-intl";
import { Accordion, AccordionItemProps } from "@/shared/ui/Accordion";
import { Typography } from "@/shared/ui/Typography";
import { BLACK_COLOR } from "@/styles/colorsJS";

const FAQItems: AccordionItemProps[] = [
  {
    value: "1",
    title: <FormattedMessage defaultMessage="Что такое Договор факторинга?" />,
    children: (
      <FormattedMessage
        defaultMessage="Договор факторинга – это соглашение, по которому Финансовый агент (ТОО
        «МФО «CreditNova») передает (или обязуется передать) Сумму
        финансирования Клиенту, а Клиент уступает (или обязуется уступить)
        Финансовому агенту свое Денежное требование к Должнику, вытекающее из
        Трудового договора/Договора ГПХ, в обеспечение обязательств Клиента по
        возврату Суммы финансирования и уплате Вознаграждения и иных платежей и
        расходов"
      />
    ),
  },
  {
    value: "2",
    title: (
      <FormattedMessage defaultMessage="Кто является сторонами Договора?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Финансовый агент: ТОО «МФО «CreditNova», которое предоставляет денежные
        средства (Сумму финансирования). Клиент: Физическое лицо, состоящее в
        отношениях с Должником как Работник (по Трудовому договору) или
        Исполнитель/Подрядчик (по Договору гражданско-правового характера).
        Клиент принимает на себя основную обязанность по возврату Суммы
        финансирования и уплате Вознаграждения. Должник: Организация
        (Работодатель или Заказчик Клиента), которая обязана произвести платеж
        по Основному договору"
      />
    ),
  },
  {
    value: "3",
    title: (
      <FormattedMessage defaultMessage="Какой вид факторинга используется в данном Договоре?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Согласно основным условиям, используется Факторинг с правом регресса.
        Это означает, что Клиент отвечает за возврат средств в случае отказа в
        перечислении денежных средств Должником (Работодателем/Заказчиком)"
      />
    ),
  },
  {
    value: "4",
    title: (
      <FormattedMessage defaultMessage='Что означает "Факторинг с правом регресса"?' />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Факторинг с правом регресса означает, что Клиент несет ответственность
        за возврат Финансовому агенту предоставленной Суммы финансирования и
        Вознаграждения"
      />
    ),
  },
  {
    value: "5",
    title: (
      <FormattedMessage defaultMessage="Какое денежное требование может быть уступлено?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Уступаемое Денежное требование — это право Клиента на получение от
        Должника денежных средств, возникшее из Основного договора (Трудовой
        договор или Договор гражданско-правового характера). Это может быть
        заработная плата, премии или вознаграждение за работы/услуги"
      />
    ),
  },
  {
    value: "6",
    title: (
      <FormattedMessage defaultMessage="Что такое Сумма финансирования и Вознаграждение?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Сумма финансирования – денежные средства, которые Финансовый агент
        предоставляет Клиенту. Вознаграждение (интерес) – плата, которую Клиент
        уплачивает Финансовому агенту за пользование деньгами, начисляемая
        ежедневно на сумму непогашенного финансирования"
      />
    ),
  },
  {
    value: "7",
    title: (
      <FormattedMessage defaultMessage="Как начисляется Вознаграждение?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Вознаграждение начисляется ежедневно на сумму непогашенного
        финансирования. Отсчет срока для начисления начинается со дня
        перечисления Суммы финансирования Клиенту и заканчивается днем
        фактического исполнения Клиентом или Должником обязательства по возврату
        Суммы финансирования (включительно)"
      />
    ),
  },
  {
    value: "8",
    title: (
      <FormattedMessage defaultMessage="Может ли Финансовый агент изменять условия Договора?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Финансовый агент имеет право изменить условия договора в одностороннем
        порядке в сторону их улучшения для клиента"
      />
    ),
  },
  {
    value: "9",
    title: (
      <FormattedMessage defaultMessage="Как происходит оплата Должником (Работодателем/Заказчиком)?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Должник обязан произвести платеж новому кредитору – Финансовому агенту –
        при условии, что он получил от Клиента либо от Финансового агента
        письменное уведомление об уступке денежного требования. Клиент
        направляет Должнику Требование об удержании и перечислении части
        заработной платы/вознаграждения Финансовому агенту. Любая выплата
        указанной суммы непосредственно Клиенту после уведомления Должника будет
        считаться ненадлежащим исполнением обязательства и не освободит Должника
        от обязанности перечислить сумму Финансовому агенту в полном объеме.
        Уступка осуществляется только в отношении суммы после удержания налогов
        и обязательных платежей, подлежащих перечислению Должником как налоговым
        агентом"
      />
    ),
  },
  {
    value: "10",
    title: (
      <FormattedMessage defaultMessage="В каких целях обрабатываются персональные данные Клиента?" />
    ),
    children: (
      <FormattedMessage
        defaultMessage="Согласие на сбор и обработку персональных данных дается, в том числе,
        для следующих целей: Заключение и исполнение Договора факторинга,
        включая проверку достоверности предоставленных сведений. Идентификация
        Клиента. Оценка платежеспособности. Ведение учета и расчетов по
        Договору. Для судебной и внесудебной защиты прав МФО в случае нарушения
        Клиентом своих обязательств"
      />
    ),
  },
];

export function FAQ() {
  return (
    <section className="flex-col-gap-10 lgc:px-0 lgc:mb-0 container mt-[var(--landing-section-gap)] mb-[var(--landing-section-gap)] px-4">
      <Typography as="h2" type="h1" color={BLACK_COLOR}>
        FAQ
      </Typography>
      <Accordion type="single" content={FAQItems} />
    </section>
  );
}
